import { Component, OnInit, Input } from '@angular/core';
import { Datipreventivo, typedati } from '../model/datipreventivo';
import { Observable } from 'rxjs/Observable';
import { NumberSymbol } from '@angular/common';
import { ComparatoregasComponent } from '../comparatoregas/comparatoregas.component';
@Component({
  selector: 'app-comparatoreele',
  templateUrl: './comparatoreele.component.html',
  styleUrls: ['./comparatoreele.component.scss']
})

export class ComparatoreeleComponent implements OnInit {

  static _consumoannuonoto: string;
  static _consumoannuopersone: number;
  init: boolean;

  static _lavastovigle: boolean;
  static _forno: boolean;
  static _condizionatore: boolean;
  static _lavatrice: boolean;
  static _scaldabagno: boolean;
  static _frigorifero: boolean;
  static _consumoannuoManuale: number;
  static _potenza: string;
  // set consumoannuonoto(value:boolean){
  //   this._consumoannuonoto=value;
  // }

  // get consumoannuonoto(){
  //   return this._consumoannuonoto;
  // }
  set consumoannuonoto(dato: string) {
    ComparatoreeleComponent._consumoannuonoto = dato;
    if (dato=="true") {
      this.lavastovigle = false;
      this.forno = false;
      this.condizionatore = false;
      this.lavatrice = false;
      this.scaldabagno = false;
      this.frigorifero = false;
      this.consumoannuopersone="0";
    }
    else
    {
      ComparatoreeleComponent._consumoannuoManuale = 0;
    }
    this.consumoannuocalcolo();
  }
  get consumoannuonoto() {
    return ComparatoreeleComponent._consumoannuonoto;
  }
  set modalitapagamento(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 6)[0].valore = dato;
  }
  get modalitapagamento() {
    return this._dati.datiextra.filter(o => o.idDato == 6)[0].valore;
  }

  set lavastovigle(dato: boolean) {
    ComparatoreeleComponent._lavastovigle = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get lavastovigle() {
    return ComparatoreeleComponent._lavastovigle;
  }
  set forno(dato: boolean) {
    ComparatoreeleComponent._forno = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get forno() {
    return ComparatoreeleComponent._forno;
  }
  set condizionatore(dato: boolean) {
    ComparatoreeleComponent._condizionatore = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get condizionatore() {
    return ComparatoreeleComponent._condizionatore;
  }
  set lavatrice(dato: boolean) {
    ComparatoreeleComponent._lavatrice = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get lavatrice() {
    return ComparatoreeleComponent._lavatrice;
  }
  set scaldabagno(dato: boolean) {
    ComparatoreeleComponent._scaldabagno = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get scaldabagno() {
    return ComparatoreeleComponent._scaldabagno;
  }
  set frigorifero(dato: boolean) {
    ComparatoreeleComponent._frigorifero = dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get frigorifero() {
    return ComparatoreeleComponent._frigorifero;
  }

  get consumoannuoelettrodomestici() {
    return (40 * (this.lavastovigle ? 1 : 0)) + (400 * (this.forno ? 1 : 0)) + (190 * (this.lavatrice ? 1 : 0)) + (1000 * (this.scaldabagno ? 1 : 0)) + (240 * (this.condizionatore ? 1 : 0)) + (400 * (this.frigorifero ? 1 : 0));
  }
  set consumoannuo(dato: string) {
    // this._dati.datiextra.filter(o => o.idDato == 1)[0].valore = dato;
    ComparatoreeleComponent._consumoannuoManuale = +dato;
    ComparatoreeleComponent._consumoannuopersone = 0;
    ComparatoreeleComponent._lavastovigle = false;
    ComparatoreeleComponent._forno = false;
    ComparatoreeleComponent._condizionatore = false;
    ComparatoreeleComponent._lavatrice = false;
    ComparatoreeleComponent._scaldabagno = false;
    ComparatoreeleComponent._frigorifero = false;

  };
  get consumoannuo() {

    this.consumoannuocalcolo();
    return this._dati.datiextra.filter(o => o.idDato == 1)[0].valore;// (this.consumoannuoelettrodomestici + ComparatoreeleComponent._consumoannuopersone+ComparatoreeleComponent._consumoannuoManuale).toString(); //this.dati.datiextra.filter(o => o.idDato == 1)[0].valore;

  };
  set tipocontratto(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 5)[0].valore = dato;
  };
  get tipocontratto() {
    return this._dati.datiextra.filter(o => o.idDato == 5)[0].valore;
  };

  set tipoprofilo(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 2)[0].valore = dato;
  };

  get tipoprofilo() {
    return this._dati.datiextra.filter(o => o.idDato == 2)[0].valore;
  };


  set residente(dato: string) {
    this._dati.datiextra.filter(o => o.idDato == 3)[0].valore = dato;
  };
  get residente() {
    
    return this._dati.datiextra.filter(o => o.idDato == 3)[0].valore;
  };
  set potenza(dato: string) {
    ComparatoreeleComponent._potenza=dato;

    if (dato =="1" || dato=="2")
    {
      this._dati.datiextra.filter(o => o.idDato == 4)[0].valore = "3";
    }
    else
    {
      this._dati.datiextra.filter(o => o.idDato == 4)[0].valore = "4.5";
    }
  };
  get potenza() {
    return ComparatoreeleComponent._potenza;
     
  };

  set consumoannuopersone(dato: string) {
    ComparatoreeleComponent._consumoannuopersone = +dato;
    ComparatoreeleComponent._consumoannuoManuale = 0;
    this.consumoannuocalcolo();
  }
  get consumoannuopersone() {
    return ComparatoreeleComponent._consumoannuopersone.toString();
  }


  constructor() {

    // this.consumoannuonoto = true;
    // this._consumoannuopersone = 1200;
    // this.lavastovigle = false;
    // this.forno = false;
    // this.condizionatore = false;
    // this.lavatrice = false;
    // this.scaldabagno = false;
    // this.frigorifero = false;
    // this.init = true;

  }
  private _dati: Datipreventivo;

  @Input('dati') set dati(dato: Datipreventivo) {
    this._dati = dato;
    if (ComparatoreeleComponent._consumoannuopersone == null) {
      ComparatoreeleComponent._consumoannuopersone =0;
      ComparatoreeleComponent._consumoannuoManuale = +dato.datiextra.filter(o => o.idDato == 1)[0].valore
      ComparatoreeleComponent._consumoannuonoto = "true";
      ComparatoreeleComponent._potenza="2";
    }
  }
  get dati(): Datipreventivo {
    return this._dati;
  }


  ngOnInit() {
    console.log(this.dati);
    // this.dati.datiextra.filter(o => o.idDato == 5)[0].valore = "1";
    // this.dati.datiextra.filter(o => o.idDato == 4)[0].valore = "3";
    // this.dati.datiextra.filter(o => o.idDato == 3)[0].valore = "1";
    // this.dati.datiextra.filter(o => o.idDato == 2)[0].valore = "1";
    // this.dati.datiextra.filter(o => o.idDato == 1)[0].valore = "1200";

  }

  private consumoannuocalcolo() {
    if (this._dati != null)
      this._dati.datiextra.filter(o => o.idDato == 1)[0].valore = (this.consumoannuoelettrodomestici + ComparatoreeleComponent._consumoannuopersone+ComparatoreeleComponent._consumoannuoManuale).toString();
    else
    {
      ComparatoreeleComponent._consumoannuopersone = 0;
      ComparatoreeleComponent._consumoannuoManuale=0;
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/comparatoreele/comparatoreele.component.ts